/* eslint-disable @typescript-eslint/no-unused-vars */
import { ViewLarge, ViewMedium, Viewport } from '@shared-ui/viewport-context';
import React, { useEffect, useState } from 'react';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { mediaQueries } from 'src/components/common/utils/component-styles';
import { checkValue } from 'src/components/functions';

const LEVEL_1 = 19.86;
const LEVEL_2 = 38.53;
const LEVEL_3 = 55.35;

const LEVEL_1_TAB = 19.00;
const LEVEL_2_TAB = 37.50;
const LEVEL_3_TAB = 52.50;

const LEVEL_1_MOBILE = 17.80;
const LEVEL_2_MOBILE = 36.00;
const LEVEL_3_MOBILE = 52.00;

const levels = {
  desktop: {
    LEVEL_1,
    LEVEL_2,
    LEVEL_3
  },
  mobile: {
    LEVEL_1: LEVEL_1_MOBILE,
    LEVEL_2: LEVEL_2_MOBILE,
    LEVEL_3: LEVEL_3_MOBILE
  },
  tablet: {
    LEVEL_1: LEVEL_1_TAB,
    LEVEL_2: LEVEL_2_TAB,
    LEVEL_3: LEVEL_3_TAB
  }
};


const V2ProgressBar: React.FC<any> = (props: any) => {
  const { backgroundColor, width } = props;

  const { width: windowWidth } = useWindowDimensions();

  let windowSize = '';
  if (windowWidth > 920) windowSize = 'desktop';
  else if (windowWidth > 767) windowSize = 'tablet';
  else windowSize = 'mobile';

  const [text, setText] = useState('');

  useEffect(() => {
    const _width = stringToNumber(width);
    const level_1 = levels[windowSize]?.LEVEL_1 || LEVEL_1;
    const level_2 = levels[windowSize]?.LEVEL_2 || LEVEL_2;
    const level_3 = levels[windowSize]?.LEVEL_3 || LEVEL_3;

    if (_width >=  level_1 && _width < level_2) {
      setText('10% off');
    } else if (_width >= level_2 && _width < level_3) {
      setText('15% off');
    } else if (_width >= level_3) {
      setText('20% off');
    } else {
      setText('');
    }
  }, [width]);

  const stringToNumber = (text: string) => {
    return parseFloat(text.replace(/(\d+\.\d{2})\d*/, (match, p1) => `${p1}%`));
  }

  return (
    <div className="progress-bar-wrapper">
      <div className={`progress-bar v2`} style={{ backgroundColor, width }}>
        {checkValue(text) &&
          <div className={`label-wrapper`}>
            <span>{`${text}`}</span>
            <img src='https://mesocp2-2.azureedge.net/media/4g2lidlk/progressbar-label.png' />
          </div>}
      </div>
    </div>
  );
};

export { V2ProgressBar };
